import React from 'react'
import { Form, Input, Label, Header, Segment, Grid, GridColumn, GridRow, Container, Icon } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundUrlAnswGood from '../assets/000003.mp3'
import soundUrlAnswBad from '../assets/000004.mp3'


class FormTwoPlayers extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            answer: '',
            starting_time: null,
            msToAnswer: props.msToAnswer,
            twoWords:props.twoWords,
            jump:props.jump,
            playerNumber:props.playerNumber,
            isRunning:true,
            rightAnswer:false,
            soundWrong1:false,
            soundWrong2:false,
            soundWrong3:false,
            soundWrong4:false,
            numberOfMistakes:0,

        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
        this.focusTextInput();
    }

    onAnswerChange = (e) => this.setState({ answer: e.target.value })

    onSubmit = (e) => {
        e.preventDefault()
        let toGuess = this.state.playerNumber == 1?this.state.twoWords.word1:this.state.twoWords.word2;
        if (this.state.answer.toUpperCase() == toGuess){
            this.setState({msToAnswer:this.state.msToAnswer, isRunning:false, rightAnswer:true})
        }else{
            this.setState({msToAnswer:this.state.msToAnswer-this.state.jump})
            let numbMist = this.state.numberOfMistakes;
                switch(this.state.numberOfMistakes){
                    case 0:
                        this.setState({soundWrong1:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 1:
                        this.setState({soundWrong2:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 2:
                        this.setState({soundWrong3:true, numberOfMistakes:numbMist+1 })
                        break;
                    case 3:
                        this.setState({soundWrong4:true, numberOfMistakes:numbMist+1 })
                        break;
                    default:
                        break;
                }
        }
        return false
    }

    onTimerFinished = () => {
        this.setState({isRunning:false})
    }

    handleAnswerDummy = (result) =>{
    }


    render() {
        const {msToAnswer, twoWords, rightAnswer,soundWrong1, soundWrong2, soundWrong3, soundWrong4 } = this.state
        const { word1, word2 } = twoWords
        return (
            <div>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"Due parole"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>"QUALE È LA TUA PAROLA "</Header>
                        {rightAnswer?<audio ref="audio_tag" src={soundUrlAnswGood} autoPlay/>:""}
                        {soundWrong1?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong2?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong3?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {soundWrong4?<audio ref="audio_tag" src={soundUrlAnswBad} autoPlay/>:""}
                        {"C'è un altro spettatore attivo. Ha una parola per te. Fattela dire e inseriscila più in fretta che puoi. In cambio tu dagli la parola che vedi qui sotto a sinistra."}
                        <Grid centered celled>
                            <GridRow >
                               <GridColumn centered width={8}>
                               <Container textAlign='center'>
                               <Label size={'huge'} color={'blue'}> <Icon name='chat'/> {this.state.playerNumber==1?word2:word1}</Label>
                                </Container>
                               </GridColumn>
                            {rightAnswer?
                               <GridColumn centered width={8}>
                               <Container textAlign='center'>
                                <Label  size={'huge'} color={'red'}><Icon name='sound'/>{this.state.playerNumber==1?word1:word2}</Label>
                                </Container>
                               </GridColumn>
                            :
                            <GridColumn centered width={8}>
                            <Container textAlign='center'>
                             <Label  size={'huge'} color={'red'}>???????</Label>
                             </Container>
                            </GridColumn>
                            }
                            </GridRow>
                            <GridRow >
                               <GridColumn centered width={16}>
                            {!rightAnswer?
                               <Container textAlign='center'>
                               <Form onSubmit={this.onSubmit} style={{ textAlign: 'left' }}>
                                        <div style={{ textAlign: 'center' }}>
                                            <Form.Field>
                                                <Input onChange={this.onAnswerChange}>
                                                    <input ref={this.setTextInputRef} value={this.state.answer} style={{ textAlign: 'center' }} />
                                                </Input>
                                            </Form.Field>
                                            <Form.Button primary type="submit">Rispondi</Form.Button>   
                                        </div>
                                </Form>
                               </Container>:
                                <Container textAlign='center'>
                                    <Label  size={'massive'} color={'green'}> <Icon name='thumbs up'/>Giusto!</Label>
                                </Container>
                            }
                               </GridColumn>
                            </GridRow>
                        </Grid>
                        <Timer  ms={msToAnswer} bar={false} isReady={true} isRunning={this.state.isRunning} handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished}/>
                    </div>
                    <Timer  ms={msToAnswer} isReady={true} isRunning={this.state.isRunning} bar={true}  handleAnswer={this.handleAnswerDummy} onTimerFinished ={this.onTimerFinished} />
                </Segment>
            </div>
        )
    }

}

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    twoWords:state.game?state.game.twoWords:undefined,
    playerNumber: state.game?state.game.playerNumber:undefined,
})

const mapDispatchToProps = (dispatch, { socket }) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormTwoPlayers)


// WEBPACK FOOTER //
// ./src/components/FormTwoPlayers.js